import React from "react";
import { Form, Table } from "react-bootstrap";
import AutoComplete from "./AutoComplete";

export const SubmittedBySection = ({ sections, user, current_date }) => {
  if (
    !(
      sections.contact_name ||
      sections.today_date ||
      sections.contact_phone_email
    )
  ) {
    return null;
  }

  return (
    <Table bordered className="my-4">
      <thead className="fs-4">
        <tr>
          <th
            colSpan={
              sections.today_date && sections.contact_name
                ? 0
                : sections.today_date || sections.contact_name
                ? 2
                : 3
            }
          >
            Submitted By
          </th>
          {sections.contact_name && (
            <td>{user?.proposal_point_contact_name}</td>
          )}
          {sections.today_date && <td>Date: {current_date}</td>}
        </tr>
      </thead>
      <tbody>
        {sections.contact_phone_email && (
          <tr>
            <td>Contact</td>
            <td>{user?.proposal_point_contact_phone}</td>
            <td>{user?.proposal_point_contact_email}</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export const ProjectInfoSection = ({
  sections,
  proposalValues,
  handleChange,
  disable_fields,
}) => (
  <Table bordered className="my-4">
    <thead className="fs-3">
      <tr>
        <th className="text-start">Project Name</th>
        <th className="text-center">
          <Form.Control
            type="text"
            name="project_name"
            placeholder="Project Name"
            className="text-center w-100"
            style={{
              border: "none",
              background: "none",
              fontSize: "16px",
              fontWeight: "bold",
            }}
            value={proposalValues.project_name}
            onChange={handleChange}
            disabled={disable_fields ? true : false}
          />
        </th>
      </tr>
    </thead>
    {sections.project_address ? (
      <tbody>
        <tr className="fs-4">
          <td className="text-start">Project Address</td>
          <td className="text-center">
            <AutoComplete
              onAddressSelect={handleChange}
              placeholder="Project Address"
              formControlName="project_address"
              initialValue={proposalValues?.project_address}
              disable_fields={disable_fields ? true : false}
            />
          </td>
        </tr>
      </tbody>
    ) : (
      ""
    )}
  </Table>
);

export const ClientSection = ({
  sections,
  proposalValues,
  handleChange,
  disable_fields,
}) => {
  if (!(sections.client_name || sections.client_address)) {
    return null;
  }

  return (
    <Table bordered className="my-4">
      <tbody className="fs-4">
        {sections.client_name && (
          <tr className="fs-4">
            <th>Customer</th>
            <td>
              <Form.Control
                type="text"
                name="customer_company_name"
                className="text-center w-100"
                placeholder="Customer Company Name"
                style={{ border: "none", background: "none", fontSize: "14px" }}
                onChange={handleChange}
                value={proposalValues.customer_company_name}
                disabled={disable_fields ? true : false}
              />
            </td>
          </tr>
        )}
        {sections.client_address && (
          <tr>
            <th>Address</th>
            <td>
              <AutoComplete
                onAddressSelect={handleChange}
                placeholder="Customer Address"
                formControlName="customer_address"
                initialValue={proposalValues?.customer_address}
                disable_fields={disable_fields ? true : false}
              />
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export const ProjectTeamSection = ({
  sections,
  proposalValues,
  handleChange,
  disable_fields,
  user,
}) => {
  if (
    !(
      sections.contact1 ||
      sections.contact2 ||
      sections.contact3 ||
      sections.contact4
    )
  ) {
    return null;
  }

  const contactRow = (index) =>
    sections[`contact${index}`] && (
      <tr className="fs-5" key={index}>
        <td className="text-start">
          <Form.Control
            type="text"
            name={`project_contact_${index}_name`}
            className="w-100"
            placeholder="Name"
            style={{ border: "none", background: "none" }}
            onChange={handleChange}
            value={proposalValues[`project_contact_${index}_name`]}
            disabled={disable_fields ? true : false}
          />
        </td>
        <td className="text-start">
          <Form.Control
            type="text"
            name={`project_contact_${index}_phone`}
            className="text-center w-100"
            placeholder="Phone Number"
            style={{ border: "none", background: "none" }}
            onChange={handleChange}
            value={proposalValues[`project_contact_${index}_phone`]}
            disabled={disable_fields ? true : false}
          />
        </td>
        <td className="text-center">
          <Form.Control
            type="text"
            name={`project_contact_${index}_email`}
            className="text-center w-100"
            placeholder="Email"
            style={{ border: "none", background: "none" }}
            onChange={handleChange}
            value={proposalValues[`project_contact_${index}_email`]}
            disabled={disable_fields ? true : false}
          />
        </td>
      </tr>
    );

  return (
    <Table bordered className="my-4">
      <thead className="fs-4">
        <tr>
          <th className="text-start">Project Team Name</th>
          <th className="text-center">Phone Number</th>
          <th className="text-center">Email</th>
        </tr>
      </thead>
      <tbody>
        {contactRow(1)}
        {contactRow(2)}
        {contactRow(3)}
        {contactRow(4)}
        {user?.job_site_contact_name && (
          <tr className="fs-5">
            <td className="text-start">{user?.job_site_contact_name}</td>
            <td className="text-start">{user?.job_site_contact_phone}</td>
            <td className="text-center">{user?.job_site_contact_email}</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};
